// Vendors
import { FeatureFlags, FeatureFlagsInterface } from '@openbank/cf-ui-framework';
// Constants
import { featureFlagsConfig } from '../constants/feature-flags.constants';

export const getFeatureFlagInstance = (): FeatureFlagsInterface => FeatureFlags(featureFlagsConfig);
